import React from 'react'

const AccessTrue = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M13.9997 2.3335C7.55967 2.3335 2.33301 7.56016 2.33301 14.0002C2.33301 20.4402 7.55967 25.6668 13.9997 25.6668C20.4397 25.6668 25.6663 20.4402 25.6663 14.0002C25.6663 7.56016 20.4397 2.3335 13.9997 2.3335ZM13.9997 23.3335C8.85468 23.3335 4.66634 19.1452 4.66634 14.0002C4.66634 8.85516 8.85468 4.66683 13.9997 4.66683C19.1447 4.66683 23.333 8.85516 23.333 14.0002C23.333 19.1452 19.1447 23.3335 13.9997 23.3335ZM11.6663 16.5319L19.3547 8.84352L20.9997 10.5002L11.6663 19.8335L6.99967 15.1669L8.64467 13.5219L11.6663 16.5319Z"
          fill={props.color ? props.color : '#1D79FB'}/>
  </svg>
)

export default AccessTrue
